/**
 * ピクトリンクアプリに関するURLを組み立てるクラス.
 */
export default class PictlinkAppSchemeUrlUtil {

    /**
     * iOS: App storeへのリンク
     */
    appStoreUrl = () => `https://apps.apple.com/app/apple-store/id446747531`;

    /**
     * Android: Google Playストアへのリンク
     */
    googlePlayUrl = () => `https://play.google.com/store/apps/details?id=jp.furyu.pictlink`;

    /**
     * アプリを立ち上げるユニバーサルリンク.
     *
     * @param schemePath
     */
    appUniversalLink = (schemePath) => `https://launch.pictlink.com/sp/launch_app/ul/${schemePath}`;

    /**
     * iOSアプリを立ち上げるディープリンク.
     *
     * @param schemePath
     */
    iOSDeepLink = (schemePath) => `pictlink://${schemePath}`;
}